export default __webpack_public_path__ + "static/media/plsLogo.da6e4c3b.svg";